<script>
  export let slug = false;
  export let showTooltip;
  export let header = '';
  export let subhead = '';
  export let values = [];
  export let tooltipString = 'Shift: ';
  $: klass = subhead.includes("D") ? 'positive': 'negative';
</script>

<div
  id={slug}
  class="tooltip"
  class:invisible={!showTooltip}
  data-show-tooltip={showTooltip}
>
  <div>
    {#if header}
      <p class="tooltip__header">{header}</p>
    {/if}
    {#each values as obj}
      <p class="tooltip__value">
        {@html obj}
      </p>
    {/each}
    <p>{tooltipString}<span class="{klass}">{subhead}</span></p>
  </div>
</div>
